const ProjectData = [
    {
        id: 1,
        name: "E-Sara",
        description: "An e-commerce website to buy elctronic equipment like computer,mobile and more of many brand like apple, Samsung etc. User can filter the product according to price, brand, colour and store them to the cart for the future. Adding to favourites is also facilates in the site",
        img: [require("./images/esara/1.png"), require("./images/esara/2.png"), require("./images/esara/3.png"), require("./images/esara/4.png"), require("./images/esara/5.png"), require("./images/esara/6.png"), require("./images/esara/7.png"), require("./images/esara/8.png")],
        gitlink: "https://github.com/meanish/esara",
        livehost: "https://meanish.github.io/esara",
        used: ["React", "Styled-components", "Formspree", "API", "UseReducer", "LocalStorage"],
        dataaos: "zoom-in-down"
    },
    {
        id: 2,
        name: "SASH HOTEL",
        description: "An Booking site which serves the user to check the available hotels in any place to travel with respective price tage and available services in the time of their visit to the place. Booking services will be available soon as of now only checking the hotel information is available.",
        img: [require("./images/SashHotel/1.jpg"), require("./images/SashHotel/2.jpg"), require("./images/SashHotel/3.jpg"), require("./images/SashHotel/4.jpg"), require("./images/SashHotel/5.jpg"), require("./images/SashHotel/6.jpg"), require("./images/SashHotel/7.jpg"), require("./images/SashHotel/8.jpg")],
        gitlink: "https://github.com/meanish/BookMe",
        livehost: "https://meanish.github.io/BookMe/",
        used: ["React", "SASS", "Bootstrap", "Rapid Api", "UseHooks"],
        dataaos: "zoom-out-left"
    },
    {
        id: 3,
        name: "Easy Shop",
        description: "Site facilate to check the product and add them in the cart.",
        img: [require("./images/EasyShop/1.png"), require("./images/EasyShop/2.png"), require("./images/EasyShop/3.png"), require("./images/EasyShop/4.png"), require("./images/EasyShop/5.png")],
        gitlink: "https://github.com/meanish/EasyShop",
        livehost: "https://meanish.github.io/EasyShop/",
        used: ["React", "Tailwind CSS", "UseReducer"],
        dataaos: "fade-down-left"
    },
    {
        id: 4,
        name: "E-Pizza",
        description: "A pizza shop that serves a menu of different flavour of pizza with their respective price tags.",
        img: [require("./images/pizza/1.png"), require("./images/pizza/2.png"), require("./images/pizza/3.png"), require("./images/pizza/4.png")],
        gitlink: "https://github.com/meanish/Pizza",
        livehost: "https://meanish.github.io/Pizza/",
        used: ["Jquery", "SASS", "Formspree", "HTMl"],
        dataaos: "fade-up-left" 
    },

    {
        id: 5,
        name: "Weather Forecast",
        description: "Is a user wants to know the weather of any city of the world at a moment then, Check this out !!!!!!",
        img: [require("./images/Weather/1.png"), require("./images/Weather/2.png"), require("./images/Weather/3.png")],
        gitlink: "https://github.com/meanish/WeatherForecast",
        livehost: "https://meanish.github.io/WeatherForecast/",
        used: ["React", "SASS", "Open WeatherApi", "UseHooks"],
        dataaos: "fade-up-right"
    },
    {
        id: 6,
        name: "Notepad",
        description: "Note your thoughts in the notepad for the future references..",
        img: [require("./images/todo/1.png"), require("./images/todo/2.png"), require("./images/todo/3.png"), require("./images/todo/4.png")],
        gitlink: "https://github.com/meanish/BroadMemo",
        livehost: "https://meanish.github.io/BroadMemo/",
        used: ["React", "SASS", "LocalStorage", "UseHooks"],
        dataaos: "flip-left",
    },

]

export default ProjectData